import { Component, Input } from '@angular/core';

import { CoverageNetworkTypeEnum } from '../../enums/coverage-network-type.enum';


@Component({
    selector: 'coverage-item',
    templateUrl: './coverage-item.component.html',
    styleUrls: ['./coverage-item.component.scss']
})
export class CoverageItemComponent {

    @Input() medicalCoverages: any;
    @Input() coverageTitle = '';
    @Input() networkFilter = CoverageNetworkTypeEnum.InNetwork;
}
